import PageHeader, { LegalSection } from "@/components/PageHeader";
import { EMAILS } from "@/config";

export default function TermsPage() {
  return (
    <>
      <PageHeader silk={1}
        testid="terms-header"
        eyebrow="Kullanım Koşulları"
        titleLines={["Kullanım", "Koşulları."]}
        lede="Son güncelleme: [Tarih] — Bu koşullar, Five Star mobil uygulamasının kullanımına ilişkin çerçeveyi açıklar."
      />
      <section className="bg-ivory pb-24 sm:pb-32 px-6">
        <div className="max-w-5xl mx-auto">
          <LegalSection index={1} title="Hizmetin Kapsamı">
            <p>
              Five Star, kullanıcılarına küratörlü eşleşme seçkileri (The Five), My Date istekleri, çöpçatan desteği ve geri bildirime dayalı kişiselleşme sunan, üyelik tabanlı bir dating uygulamasıdır.
            </p>
          </LegalSection>

          <LegalSection index={2} title="Yaş Şartı">
            <p>Five Star yalnızca 18 yaş ve üzeri yetişkinler içindir. Uygulamayı kullanarak 18 yaşını doldurduğunu beyan etmiş olursun.</p>
          </LegalSection>

          <LegalSection index={3} title="Kullanıcı Hesabı">
            <p>Hesap bilgilerinin güvenliğinden ve hesabın üzerinden gerçekleşen işlemlerden kullanıcı sorumludur.</p>
          </LegalSection>

          <LegalSection index={4} title="Doğru Bilgi Verme">
            <p>Kayıt sırasında ve profilinde doğru, güncel ve kendine ait bilgiler paylaşmakla yükümlüsün.</p>
          </LegalSection>

          <LegalSection index={5} title="Kullanıcı Davranışları ve Yasaklı İçerikler">
            <p>
              Taciz, nefret söylemi, yanıltıcı içerik, ticari amaçlı kullanım ve başkalarının haklarını ihlal eden davranışlar yasaktır. Bu kurallara aykırı davranışlar hesabın askıya alınması veya silinmesiyle sonuçlanabilir.
            </p>
          </LegalSection>

          <LegalSection index={6} title="Mesajlaşma">
            <p>Mesajlaşma, karşılıklı eşleşme koşulları sağlandığında kullanılabilir. Mesaj içeriklerinden kullanıcılar sorumludur.</p>
          </LegalSection>

          <LegalSection index={7} title="Eşleşmelerin Garanti Edilmemesi">
            <p>Five Star, kişisel ve özenli bir tanışma süreci sunar; ancak herhangi bir eşleşme, buluşma veya ilişki sonucu garanti etmez.</p>
          </LegalSection>

          <LegalSection index={8} title="Üyelik ve Abonelikler">
            <p>Five Star üyelik tabanlıdır. Aktif üyelik süresince The Five, My Date ve çöpçatan desteği özellikleri kullanılabilir.</p>
          </LegalSection>

          <LegalSection index={9} title="App Store Faturalandırma">
            <p>Abonelik ödemeleri Apple App Store üzerinden tahsil edilir ve faturalandırma Apple'ın koşullarına tabidir.</p>
          </LegalSection>

          <LegalSection index={10} title="Aboneliğin İptali">
            <p>
              Aboneliğini dilediğin zaman Apple ID → Abonelikler bölümünden iptal edebilirsin. İptal sonrasında, ödemesi yapılmış dönemin sonuna kadar üyelik özelliklerini kullanmaya devam edebilirsin.
            </p>
          </LegalSection>

          <LegalSection index={11} title="Hesabın Askıya Alınması ve Silinmesi">
            <p>
              Kurallara aykırı kullanım durumunda hesaplar askıya alınabilir veya silinebilir. Hesabını dilediğin zaman uygulama içinden (Ayarlar → Hesabımı Sil) kendin de silebilirsin.
            </p>
          </LegalSection>

          <LegalSection index={12} title="Şikayet ve Raporlama">
            <p>
              Uygunsuz davranışları uygulama içindeki bildirme özelliğiyle ya da <a className="text-burgundy underline underline-offset-4 decoration-burgundy/30 hover:decoration-burgundy" href={`mailto:${EMAILS.support}`}>{EMAILS.support}</a> adresine yazarak bildirebilirsin.
            </p>
          </LegalSection>

          <LegalSection index={13} title="Fikri Mülkiyet">
            <p>Five Star markası, tasarımı ve uygulama içerikleri ilgili hak sahiplerine aittir. İzinsiz kullanılamaz.</p>
          </LegalSection>

          <LegalSection index={14} title="Sorumluluk Sınırları">
            <p>
              Five Star, kullanıcılar arasındaki etkileşimlerin sonuçlarından sorumlu tutulamaz. Sorumluluk, yürürlükteki hukukun izin verdiği ölçüde sınırlandırılmıştır. <strong>[Hukuki inceleme notu]</strong>
            </p>
          </LegalSection>

          <LegalSection index={15} title="Değişiklikler">
            <p>Bu koşullar zaman zaman güncellenebilir. Güncel metin her zaman bu sayfada yayınlanır.</p>
          </LegalSection>

          <LegalSection index={16} title="İletişim">
            <p>
              Kullanım koşullarıyla ilgili soruların için: <a className="text-burgundy underline underline-offset-4 decoration-burgundy/30 hover:decoration-burgundy" href={`mailto:${EMAILS.hello}`}>{EMAILS.hello}</a>
            </p>
          </LegalSection>
        </div>
      </section>
    </>
  );
}
